
<!-- Navbar -->
<app-navbar-style-two></app-navbar-style-two>

<!-- Search Area -->
<section class="search-area">

    <div class="container">

        <div class="row justify-content-center">

            <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">

                <div class="input-box">

                    <i class="uil uil-search search-icon"></i>

                    <input
                        type="text"
                        placeholder="Search products..."
                        name="search_value"
                        [(ngModel)]="searchValue"
                        (keyup.enter)="searchValue && searchValue.trim() "
                    />

                    <button
                        class="button"
                        type="button"
                        [disabled]="!searchValue || !searchValue.trim()"
                        [routerLink]="['/search-product', searchValue.trim()]">

                        <i class="bx bx-search"></i>

                    </button>

                </div>

            </div>

        </div>

    </div>

</section>
